import React, { useState, useRef, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import environmentVariables from "../../../config/environmentVariables";

const DescriptionIcon = `${environmentVariables?.cdnUrl}Description.svg`
const DetailIcon      = `${environmentVariables?.cdnUrl}destail.svg`
const PropertiesIcon  = `${environmentVariables?.cdnUrl}properties.svg`

import axios from "axios";

const Span = styled.span`
  padding: 0 10px 0 0;
`;
const Root = styled.div`
  z-index: 1;
`;

const CopyIcon = styled.div`
  color: white;
  cursor: pointer;
  padding: 0 0 0 15px;
  @media (max-width: 425px) {
    padding: 0 0 0 5px;
  }
`;
const ImageIcon = styled.img``;

const TabsNftDetails = ({ loading, data, fetchDetails }) => {
  const params = useParams();
  const copyRef = useRef(null);
  console.log(".......................................................................", data);

  const [expanded, setExpanded] = useState("panel1");
  const [conversionRate, setConversionRate] = useState(-1);
  const getConversionRates = () => {
    // let token = fetchDetails?.currency;
    // console.log(fetchDetails?.currency, "fetchdetailsforconversion");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/fetch_conversion_rate_by_currency?token=${fetchDetails?.currency}`,
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data?.data) {
          const usdconversionrate =
            response?.data?.data?.conversion_rate.filter(
              (val) => val.currency === "USD"
            );
          if (usdconversionrate.length > 0) {
            // console.log(
            //   usdconversionrate[0]?.conversion_rate,
            //   "fetchdetailsforconversion"
            // );
            setConversionRate(usdconversionrate[0]?.conversion_rate);
          }
        }
        // console.log(response?.data?.data, "fetchdetailsforconversion");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (fetchDetails) {
      getConversionRates();
    }
  }, [fetchDetails]);
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const CopyAddress = async () => {
    try {
      if (copyRef.current) {
        const addressToCopy = copyRef.current.getAttribute("data-address");
        if (addressToCopy) {
          await navigator.clipboard.writeText(addressToCopy);
          toast.success("Copied !", {
            autoClose: 1000,
          });
        } else {
          toast.error("No address to copy.");
        }
      }
    } catch (error) {
      console.error("Error copying text:", error);
      toast.error("Copy failed");
    }
  };
  return (
    <Root>
      {loading ? (
        <div
          style={{
            marginTop: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularLoader></CircularLoader>
        </div>
      ) : (
        <>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            style={{
              width: "100%",
              margin: "20px 0 10px",
              border: "1px solid #151a1c",
              color: "#fff",
              backgroundColor: "#151a1c",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Span>
                {" "}
                <ImageIcon src={DescriptionIcon} />
              </Span>
              <Typography sx={{ flexShrink: 0, fontWeight: "600" }}>
                Description
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Typography
                style={{
                  width: "90%",
                  textAlign: "justify",
                  color: "#9d9d9d",
                  wordBreak: "break-all",
                }}
              >
                {fetchDetails?.description || "  "}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            style={{
              width: "100%",
              margin: "10px 0",
              border: "1px solid #151a1c",
              color: "#fff",
              backgroundColor: "#151a1c",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Span>
                {" "}
                <ImageIcon src={PropertiesIcon} />
              </Span>
              <Typography sx={{ flexShrink: 0, fontWeight: "600" }}>
                Properties
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ display: "flex", alignItems: "center" }}>
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Hash Rate:
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {fetchDetails?.hash || "-"}
              </Typography>
            </AccordionDetails>
            {/* <AccordionDetails style={{ display: "flex", alignItems: "center" }}>
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Daily Rewards:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {fetchDetails?.dailyReward}
              </Typography>
            </AccordionDetails> */}
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            style={{
              width: "100%",
              margin: "10px 0",
              border: "1px solid #151a1c",
              color: "#fff",
              backgroundColor: "#151a1c",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <Span>
                {" "}
                <ImageIcon src={DetailIcon} />
              </Span>
              <Typography sx={{ flexShrink: 0, fontWeight: "600" }}>
                Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Owner Address:
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
                ref={copyRef}
                data-address={data?.owner}
              >
                <div style={{ display: "flex" }}>
                  {data?.owner.slice(0, 6)}.....{data?.owner.slice(-4)}
                  <CopyIcon onClick={CopyAddress}>
                    <i class="fa-solid fa-copy"></i>
                    {/* <ToastContainer position="top-left" /> */}
                  </CopyIcon>
                </div>
              </Typography>
            </AccordionDetails>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Asset Name:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {fetchDetails?.name}
              </Typography>
            </AccordionDetails>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Asset Type:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {params.contract ===
                "0x8fc3dec6148a9924870f205617c9c26b3010243e"
                  ? "Shootable"
                  : params.contract ===
                      "0x6b229c5687d00590606f97045ad65d8dfbfe1bdc" ||
                    params.contract ===
                      "0x8a41c16ed29205383cf920b7bc50846852945202" ||
                    params.contract ===
                      "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                  ? "Melee"
                  : params.contract ===
                    "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                  ? "Characters"
                  : params.contract ===
                    "0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece"
                  ? "Vehicle"
                  : null}
              </Typography>
            </AccordionDetails>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Asset SubType:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {fetchDetails?.assetType}
              </Typography>
            </AccordionDetails>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Asset Category:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {fetchDetails?.category}
              </Typography>
            </AccordionDetails>
            <AccordionDetails
              style={{
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #1d2224",
              }}
            >
              <Typography
                style={{ fontSize: "17px", color: "#9d9d9d", width: "40%" }}
              >
                Price in USD:{" "}
              </Typography>
              <Typography
                style={{
                  width:"60%",
                  padding: "0 0 0 10px",
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              >
                {conversionRate == -1
                  ? "Not available"
                  : `$${parseFloat(
                      fetchDetails?.price / conversionRate
                    ).toFixed(2)}`}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </>
      )}
    </Root>
  );
};

export default TabsNftDetails;
